<template>
  <div class="page-listings">
    
    <rfr-tour v-if="$store.state.tour & !loading && filteredRFRs.length" />
  
    <section
      v-if="loading || !rfrs"
      data-v-5a90ec03
      class="pt-5 pb-3 pixelsbg bs-shadow mobile-top"
      style="min-height: 260px"
    >
      <div data-v-5a90ec03 class="container">
        <h1 class="text-white mb0 lh1">Loading RFRs....</h1>
        <br />
        <div class="hollow-dots-spinner">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
    </section>

    <section v-else class="pt-5 pb-3 pixelsbg bs-shadow mobile-top">
      <div data-v-5a90ec03 class="container">

          <RFRReasonChart  v-if="showCharts && chartData" :data="chartData" :closeGraphs="closeGraphs"/>


        <div v-if="employee" class="row-4" style="display: flex; gap: 12px;">

  <!-- Today -->
  <div 
    class="header-bucket-wrap text-center mb10"
    :class="{ active: activePeriod === 'day' }"
    @click="openGraphs('day')"
  >
    <div class="top-back">
      <h5 class="text-white top-titles mb0">RFRs Today</h5>
      <span class="material-icons" style="font-weight: 300; font-size: 18px;"> keyboard_arrow_down </span>
      <h3 class="text-white">{{ this.stats[0]?.Today || 0 }}</h3>
    </div>
  </div>

  <!-- This Month -->
  <div 
    class="header-bucket-wrap text-center mb10"
    :class="{ active: activePeriod === 'month' }"
    @click="openGraphs('month')"
  >
    <div class="top-back">
      <h5 class="text-white top-titles mb0">RFRs This Month</h5>
      <span class="material-icons" style="font-weight: 300; font-size: 18px;"> keyboard_arrow_down </span>
      <h3 class="text-white">{{ this.stats[0]?.This_Month || 0 }}</h3>
    </div>
  </div>

  <!-- This Year -->
  <div 
    class="header-bucket-wrap text-center mb10"
    :class="{ active: activePeriod === 'year' }"
    @click="openGraphs('year')"
  >
    <div class="top-back">
      <h5 class="text-white top-titles mb0">RFRs This Year</h5>
      <span class="material-icons" style="font-weight: 300; font-size: 18px;"> keyboard_arrow_down </span>
      <h3 class="text-white">{{ this.stats[0]?.This_Year || 0 }}</h3>
    </div>
  </div>

</div>

        <div class="input-wrap">
        <input
          id="RFR-step-1"
          class="top-search mt0"
          type="text"
          placeholder="Search for RFR by order number, RFR number, or status"
          style="padding: 15px;"
          v-model="searchValue"
          @keyup.enter.prevent="searchQuery"
        />

        <button
            :class="[showButton ? 'clear-btn' : 'clear-hide']"
            @click="clearSearch"
            type="button"
            class="d-flex align-items-center pr-3 clear-btn"
          >
            <svg
              class="w-4 h-4 text-[#429da8] hover:text-[#1E3040]"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path
                d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
              ></path>
            </svg>
          </button>
        </div>


        <div class="search-btns">
          <div class="left-side">
            <div id="RFR-step-2" class="ac-select">
              <select
                class="form-control"
                id="exampleFormControlSelect1"
                v-model="acFilter"
              >
                <option :value="null" selected class="all-contractors">
                  Area Contractor
                </option>
                <option v-for="ac in acs" :key="ac.acid" :value="ac.acid">
                  {{ " " + ac.acName + " (" + ac.acid + ")" }}
                </option>
                <!--
				>{{ " " + ac.acName + " (" + ac.acid + ")" }}</option>
                -->
              </select>
            </div>

            <div class="dates" id="dates" style="margin-right: 14px;">
              <VueDatePicker v-model="startDate" 
              input-class-name="dp-custom-input"
              :enable-time-picker="false" 
              format="MMM dd yyyy"
                placeholder="From Date"
                wrapperClass="pickthedate"
                :typeable="true"
                style="padding-right: 10px;"
                ></VueDatePicker>


                <VueDatePicker v-model="endDate" 
                id="RFR-step-3"
                input-class-name="dp-custom-input"
                :enable-time-picker="false" 
                format="MMM dd yyyy"
                placeholder="To Date"
                wrapperClass="pickthedate"
                :typeable="true"
                ></VueDatePicker>

                <!--
              <datepicker
                format="MMM dd yyyy"
                placeholder="From Date"
                v-model="startDate"
                wrapperClass="pickthedate"
                :typeable="true"
              ></datepicker>
              <datepicker
                id="RFR-step-3"
                format="MMM dd yyyy"
                placeholder="To Date"
                v-model="endDate"
                wrapperClass="pickthedate"
                :typeable="true"
              ></datepicker>
                -->
            </div>
          </div>

          <div class="right-side">
            <button
              v-if="
                (searchValue || startDate || endDate || acFilter || searchStarted) &&
                !searchStarted
              "
              @click.prevent="searchQuery"
              class="search"
            >
              <span class="material-icons">search</span>
              {{ " " }} Search
            </button>
            <button v-else class="search" disabled>
              <span class="material-icons">search</span>
              {{ " " }} Search
            </button>
            <!--
            <button
              v-if="searchValue || startDate || endDate || acFilter"
              @click="clearSearch"
              class="clear"
            >
              <span class="material-icons">find_replace</span>
              {{ " " }} Clear
            </button>
            <button v-else disabled class="clear">
              <span class="material-icons">find_replace</span>
              {{ " " }} Clear
            </button>
            -->
          </div>
        </div>

        <!--
        <div class="date-area">
          <vc-calendar mode="range" v-model="attributes" :max-date="new Date()" is-inline />
        </div>
        -->
      </div>
    </section>

    <div :class="loading == false && !filteredRFRs.length ? 'message-bg' : ''">
      <div class="container">
        <div class="row">
          <div
            v-if="loading == true"
            class="col-xs-12 col-sm-12 col-12 col-lg-12"
          >
            <div class="flex-box-wrap">
              <div class="flex-internal">
                <atom-spinner
                  :animation-duration="1000"
                  :size="40"
                  :color="'#575757'"
                />
                <p>Loading......</p>
              </div>
            </div>
          </div>

          <div
            v-else-if="loading == false && !filteredRFRs.length"
            class="col-xs-12 col-sm-12 col-12 col-lg-12 flexVHcenter"
          >
            <div>
              <h2 style="margin: 30px 20px; color: #429da8; font-weight: 400">
                It looks like there are no RFRs to show...
              </h2>
              <img src="@/assets/img/noUserChoice.svg" style="width: 100%" />
            </div>
          </div>

          <div v-else class="col-xs-12 col-sm-12 col-12 col-lg-12">
            <div
              class="
                rfr-header
                d-flex
                align-items-center
                p-3
                mt-3
                mb10
                rounded
                box-shadow
              "
            >
              <p class="mrauto mb0">
                Page {{ currPage }} of
                {{ Math.ceil(this.filteredRFRs.length / 100) }}
              </p>
              <div class="pag-wrapper mlauto">
                <div id="RFR-step-4" class="nav-btns">
                  <button v-if="this.currPage === 1" disabled>
                    <i class="material-icons">keyboard_arrow_left</i> Back
                  </button>

                  <button v-else @click.prevent="setPage(currPage - 1)">
                    <i class="material-icons">keyboard_arrow_left</i> Back
                  </button>

                  <button
                    v-if="
                      this.currPage === this.totalPage ||
                      this.currPage == Math.ceil(this.filteredRFRs.length / 100)
                    "
                    disabled
                  >
                    Next
                    <i class="material-icons">keyboard_arrow_right</i>
                  </button>

                  <button v-else @click.prevent="setPage(currPage + 1)">
                    Next
                    <i class="material-icons">keyboard_arrow_right</i>
                  </button>
                </div>

                <!--
          <p class="mtauto" v-if="search.length">Results are being filtered</p>
          <p class="mtauto" v-else>Page {{currPage}} of {{ totalPage }} </p>
          <div class="nav-btns">

              <button v-if="this.currPage === 1" disabled><i class="material-icons">keyboard_arrow_left</i> Back</button>

              <button v-else @click.prevent="setPage(currPage-1)"><i class="material-icons">keyboard_arrow_left</i> Back</button>

              <button v-if="this.currPage === this.totalPage" disabled>Next <i class="material-icons">keyboard_arrow_right</i></button>

              <button v-else @click.prevent="setPage(currPage+1)">Next <i class="material-icons">keyboard_arrow_right</i></button>

          </div>
              --></div>
            </div>

            <div>
              <div class="listing">
                <h2>Request For Reimbursement</h2>
                <!--
          <div v-for="rfr in rfrs" :key="rfr.Tid">
              -->
                <div class="rfr table-responsive">
                  <table
                    class="table-striped table-bordered"
                    style="display: table; min-width: 100%"
                  >
                    <thead>
                      <tr>
                        <th
                          @click="sortCol('rfrNo')"
                          class="table-link"
                          :class="columnSort == 'rfrNo' ? 'column-active' : ''"
                          scope="col"
                        >
                          <span style="display: flex; flex: 0 0 100%">
                            <span>ID </span>
                            <span class="ml-auto">
                              <i
                                :class="
                                  columnSort == 'rfrNo'
                                    ? 'carrot-icon-active'
                                    : ''
                                "
                                class="material-icons carrot-icon"
                              >
                                filter_list
                              </i>
                            </span>
                          </span>
                        </th>
                        <th
                          @click="sortCol('orderNo')"
                          class="table-link"
                          :class="
                            columnSort == 'orderNo' ? 'column-active' : ''
                          "
                          scope="col"
                        >
                          <span style="display: flex; flex: 0 0 100%">
                            <span>Order # </span>
                            <span class="ml-auto">
                              <i
                                :class="
                                  columnSort == 'orderNo'
                                    ? 'carrot-icon-active'
                                    : ''
                                "
                                class="material-icons carrot-icon"
                              >
                                filter_list
                              </i>
                            </span>
                          </span>
                        </th>
                        <th
                          @click="sortCol('acid')"
                          class="table-link thirty"
                          :class="columnSort == 'acid' ? 'column-active' : ''"
                          scope="col"
                        >
                          <span style="display: flex; flex: 0 0 100%">
                            <span>AC </span>
                            <span class="ml-auto">
                              <i
                                :class="
                                  columnSort == 'acid'
                                    ? 'carrot-icon-active'
                                    : ''
                                "
                                class="material-icons carrot-icon"
                              >
                                filter_list
                              </i>
                            </span>
                          </span>
                        </th>
                        <th
                          @click="sortCol('createdByUser')"
                          class="table-link"
                          :class="
                            columnSort == 'createdByUser' ? 'column-active' : ''
                          "
                          scope="col"
                        >
                          <span style="display: flex; flex: 0 0 100%">
                            <span>Requester </span>
                            <span class="ml-auto">
                              <i
                                :class="
                                  columnSort == 'createdByUser'
                                    ? 'carrot-icon-active'
                                    : ''
                                "
                                class="material-icons carrot-icon"
                              >
                                filter_list
                              </i>
                            </span>
                          </span>
                        </th>
                        <th
                          @click="sortCol('dateCreated')"
                          class="table-link"
                          :class="
                            columnSort == 'dateCreated' ? 'column-active' : ''
                          "
                          scope="col"
                        >
                          <span style="display: flex; flex: 0 0 100%">
                            <span>Submitted </span>
                            <span class="ml-auto">
                              <i
                                :class="
                                  columnSort == 'dateCreated'
                                    ? 'carrot-icon-active'
                                    : ''
                                "
                                class="material-icons carrot-icon"
                              >
                                filter_list
                              </i>
                            </span>
                          </span>
                        </th>
                        <th
                          @click="sortCol('requestReason')"
                          class="table-link"
                          :class="columnSort == 'requestReason' ? 'column-active' : ''"
                          scope="col"
                        >
                          <span style="display: flex; flex: 0 0 100%">
                            <span>Reason</span>
                            <span class="ml-auto">
                              <i
                                :class="
                                  columnSort == 'requestReason'
                                    ? 'carrot-icon-active'
                                    : ''
                                "
                                class="material-icons carrot-icon"
                              >
                                filter_list
                              </i>
                            </span>
                          </span>
                        </th>
                        <th
                          @click="sortCol('status')"
                          class="table-link ten"
                          :class="columnSort == 'status' ? 'column-active' : ''"
                          scope="col"
                        >
                          <span style="display: flex; flex: 0 0 100%">
                            <span>Status </span>
                            <span class="ml-auto">
                              <i
                                :class="
                                  columnSort == 'status'
                                    ? 'carrot-icon-active'
                                    : ''
                                "
                                class="material-icons carrot-icon"
                              >
                                filter_list
                              </i>
                            </span>
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-bind:key="rfr.OrderNumber"
                        v-for="(rfr, index) in filteredRFRs.slice(
                          pageStart,
                          pageStart + countOfPage
                        )"
                      >
                        <td>
                          <router-link
                            :to="/rfr-details/ + rfr.rfrNo"
                            :id="index === 0 ? 'RFR-step-5' : ''"
                            >{{ rfr.rfrNo }}</router-link
                          >
                        </td>
                        <td>
                          <router-link
                            :to="/order-details/ + rfr.orderNo"
                            :id="index === 0 ? 'RFR-step-6' : ''"
                          >
                            {{ rfr.orderNo }}
                          </router-link>
                        </td>
                        <td>{{ rfr.acName + " (" + rfr.acid + ")" }}</td>
                        <td>{{ rfr.createdByUser }}</td>
                        <td>
                          {{ $moment(rfr.dateCreated).format("MM-DD-YYYY") }}
                        </td>
                        <td>{{ rfr.requestReason }}</td>
                        <td>{{ rfr.status }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- card -->
              </div>
            </div>
            <div
              class="
                rfr-header
                d-flex
                align-items-center
                p-3
                mt10
                mb-3
                rounded
                box-shadow
              "
            >
              <p class="mrauto mb0">
                Page {{ currPage }} of
                {{ Math.ceil(this.filteredRFRs.length / 100) }}
              </p>
              <div class="pag-wrapper mlauto">
                <div class="nav-btns">
                  <button v-if="this.currPage === 1" disabled>
                    <i class="material-icons">keyboard_arrow_left</i> Back
                  </button>

                  <button v-else @click.prevent="setPage(currPage - 1)">
                    <i class="material-icons">keyboard_arrow_left</i> Back
                  </button>

                  <button
                    v-if="
                      this.currPage === this.totalPage ||
                      this.currPage == Math.ceil(this.filteredRFRs.length / 100)
                    "
                    disabled
                  >
                    Next
                    <i class="material-icons">keyboard_arrow_right</i>
                  </button>

                  <button v-else @click.prevent="setPage(currPage + 1)">
                    Next
                    <i class="material-icons">keyboard_arrow_right</i>
                  </button>
                </div>

                <!--
          <p class="mtauto" v-if="search.length">Results are being filtered</p>
          <p class="mtauto" v-else>Page {{currPage}} of {{ totalPage }} </p>
          <div class="nav-btns">

              <button v-if="this.currPage === 1" disabled><i class="material-icons">keyboard_arrow_left</i> Back</button>

              <button v-else @click.prevent="setPage(currPage-1)"><i class="material-icons">keyboard_arrow_left</i> Back</button>

              <button v-if="this.currPage === this.totalPage" disabled>Next <i class="material-icons">keyboard_arrow_right</i></button>

              <button v-else @click.prevent="setPage(currPage+1)">Next <i class="material-icons">keyboard_arrow_right</i></button>

          </div>
              --></div>
            </div>
          </div>
          <!-- end other column -->
        </div>
      </div>
      <!-- container -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
import VueDatePicker from '@vuepic/vue-datepicker';
// import Datepicker from "vuejs-datepicker";
import rfrTour from "../components/Tours/rfrTour.vue";
import RFRReasonChart from "@/components/DataViz/RFRReasonChart.vue";



const auth = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
  },
};

export default {
  name: "RFRs",
  components: {
    AtomSpinner,
    VueDatePicker,
    // Datepicker,
    rfrTour,
    RFRReasonChart
  },
  data() {
    return {
      ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
      backend: import.meta.env.VITE_APP_SERVER_URL,
      searchValue: "",
      search: "",
      storedListings: [],
      searchRender: false,
      startDate: null,
      endDate: null,
      searchStarted: false,
      acs: [],
      rfrs: [],
      showCharts: false,
      chartData: null,
      activePeriod: null,
      stats: null,
      charts: null,
      selectedCat: "Show All",
      acFilter: null,
      searching: false,
      loading: true,
      countOfPage: 100,
      currPage: 1,
      noRFRFound: false,
      forumCats: [
        { id: 0, name: "Show All" },
        { id: 1, name: "Configura" },
        { id: 2, name: "Marketing" },
        { id: 3, name: "Other" },
        { id: 4, name: "Process" },
        { id: 5, name: "Product" },
        { id: 6, name: "Spacenet" },
      ],
      colSort: false,
      columnSort: "",
    };
  },
  methods: {
    firstLoad: function () {
      this.loading = true;
      this.searchValue = "";
      this.startDate = null;
      this.acFilter = null;
      this.endDate = null;
      this.searchStarted = false;
      this.$store.commit("setActivePage", "order-manage");
      this.loadStats();
      this.loadCharts();
      this.acListSync();
      //return axios.get(this.endPointCompute, auth).then((response) => {
      return axios.get(`${this.ordermanageapi}/rfr/`, auth).then((response) => {
        //console.log(response);
        //let theData = response.data
        this.rfrs = response.data;
        this.loading = false;
      });
    },

    acListSync: function () {
      //this.loading = true;

      if (!this.$store.state.acList.acList.length) {
        //console.log("getting acList");
        return axios
          .get(`${this.ordermanageapi}/aclist?active=true`, auth)
          .then((response) => {
            //console.log(response);
            const data = response.data;

            /*

            const low = data.filter(function (e) {
              return e.acid < 210;
            });

            const mid = data.filter(function (e) {
              return e.acid == 80069;
            });

            const high = data.filter(function (e) {
              return e.acid > 800000 && e.acid < 800250;
            });

            const all = low.concat(high).concat(mid);
            const alph = all.sort((a, b) => (a.acName > b.acName ? 1 : -1));
            */

            const alph = data.sort((a, b) => (a.acName > b.acName ? 1 : -1));
            this.acs = alph;
            //this.loading = false;
            this.$store.commit("UPDATE_ACLIST", this.acs);
          });
      } else {
        //console.log("vuex has length");
        this.acs = this.$store.state.acList.acList;
        //this.loading = false;
      }
    },

    loadStats(){
      return axios
                .get(`${this.backend}/api/v1/rfr/stats`, auth)
                .then((response) => {
                    if (response.status === 401) {
                        // this.Logout();
                        this.$router.push("/");
                    } else {
                   
                        this.stats = response.data.stats;
                    }
                })
                .catch((error) => {
                    // console.log(error);
                    localStorage.removeItem("SSCUSER");
                    this.$router.push("/");
                });
    },

    loadCharts(){
      return axios
                .get(`${this.backend}/api/v1/rfr/charts`, auth)
                .then((response) => {
                    if (response.status === 401) {
                        // this.Logout();
                        this.$router.push("/");
                    } else {
                   
                        this.charts = response.data;
                    }
                })
                .catch((error) => {
                    // console.log(error);
                    localStorage.removeItem("SSCUSER");
                    this.$router.push("/");
                });
    },

    openGraphs(type) {
      this.activePeriod = type;
      if (type === "day") {
        this.chartData = this.charts.today;
      } else if (type === "month") {
        this.chartData = this.charts.thisMonth;
      } else if (type === "year") {
        this.chartData = this.charts.thisYear;
      }
      this.showCharts = true;
    },

    closeGraphs() {
      this.showCharts = false;
      this.chartData = null;
      this.activePeriod = null;
    },

    toUpperCase: function (str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.toUpperCase();
      });
    },

    searchReset: function () {
      this.selectedCat = "Show All";
    },

    setPage: function (idx) {
      this.search = "";
      if (idx <= 0 || idx > this.totalPage) {
        return;
      }
      this.currPage = idx;
    },

    catSwitcher: function (catType) {
      //console.log(catType);
      let category = catType;
      //console.log(category);
      if (category !== "Show All") {
        this.selectedCat = category;
        this.search = "";
        //console.log(category);
      } else {
        this.selectedCat = "Show All";
      }
    },
    searchQuery(event) {
      this.searchStarted = true;
      if (this.searchStarted === true) {
        this.storedListings = this.rfrs;
      }

      this.search = "";
      this.loading = true;
      this.searching = true;

      //console.log(event);

      //console.log(`${this.ordermanageapi}/orders?search=${this.searchValue}`);
      /*
			return axios;
				.get(`${this.ordermanageapi}/order?search=${this.searchValue}`, auth)
				.then((response) => {*/
      return axios.get(this.searchEndpointCompute, auth).then((response) => {
        this.rfrs = response.data;
        //console.log(response);
        this.loading = false;
        this.searching = false;
      });
    },
    clearSearch() {
      if (this.searchStarted == true) {
        this.rfrs = this.storedListings;
        this.searchStarted = false;
        this.searchRender = !this.searchRender;
      }

      //this.listings = this.storedListings;

      this.searchValue = "";
      this.startDate = null;
      this.acFilter = null;
      this.endDate = null;
      this.$forceUpdate();

      //this.$forceUpdate();
      //Vue.set(this.listings, this.storedListings);
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    sortCol: function (type) {
      this.columnSort = type;
      const COLUMN = type;
      console.log(COLUMN);
      if (this.colSort) {
        this.filteredRFRs.sort((a, b) => (a[COLUMN] > b[COLUMN] ? 1 : -1));
      } else {
        this.filteredRFRs.sort((a, b) => (a[COLUMN] < b[COLUMN] ? 1 : -1));
      }
      this.colSort = !this.colSort;
    },
  },
  computed: {
    employee() {
      return this.$store.getters.isSpacesaverEmployee;
    },
    activeNav() {
      return this.$store.state.activePage;
    },

    showButton() {
      if (this.searchValue.trim().length > 0 || this.acFilter || this.startDate || this.endDate) {
        // console.log('true')
        return true;
      } else {
        // console.log('false')
        return false;
      }
    },

    colorGetter() {
      return this.$store.state.colors;
    },

    filteredRFRs: function () {
      //set the current page to 0
      this.currPage = 1;
      //if the search box is filled in
      if (this.search.trim() !== "") {
        return this.rfrs.filter((e) => {
          //filter the subject line by what is filled in the search box
          return (
            e.OrderNumber.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          );
        });
      } else if (this.selectedCat !== "Show All") {
        this.search = "";
        //console.log(this.selectedCat);
        return this.rfrs.filter((f) => {
          return f.Type == this.selectedCat;
        });
      } else {
        return this.rfrs;
      }
    },

    foundNoRFR: function () {
      if (this.search.length > 1 && this.filteredRFRs.length === 0) {
        //this.noUserFound = true;
        return true;
      }
    },

    pageStart: function () {
      return (this.currPage - 1) * this.countOfPage;
    },

    totalPage: function () {
      return Math.ceil(this.rfrs.length / this.countOfPage);
    },
    listingRestore: function () {
      if (
        !this.searchValue &&
        !this.loading &&
        !this.searching &&
        this.storedListings.length >= this.rfrs
      ) {
        //console.log("fired off");
        this.rfrs = this.storedListings;
      }
      return;
    },
    searchEndpointCompute: function () {
      //has order number, no start, no end, no ac
      if (
        this.searchValue.length &&
        !this.startDate &&
        !this.endDate &&
        !this.acFilter
      ) {
        console.log('1')
        return `${this.ordermanageapi}/rfr?search=${this.searchValue.trim()}`;
      } else if (
        //has order number, and start, no end, no ac
        this.searchValue.length &&
        this.startDate != null &&
        this.endDate === null &&
        this.acFilter === null
      ) {
        console.log('2')
        return `${this.ordermanageapi}/rfr?search=${
          this.searchValue.trim()
        }&start=${this.formatDate(this.startDate)}`;
      } else if (
        //has order number, and end, no start, no ac
        this.searchValue.length &&
        this.startDate === null &&
        this.acFilter === null &&
        this.endDate != null
      ) {
        console.log('3')
        return `${this.ordermanageapi}/rfr?search=${
          this.searchValue.trim()
        }&end=${this.formatDate(this.endDate)}`;
      } else if (
        // has three, no ac
        this.searchValue.length &&
        this.startDate != null &&
        this.acFilter === null &&
        this.endDate != null
      ) {
        console.log('4')
        return `${this.ordermanageapi}/rfr?search=${
          this.searchValue.trim()
        }&start=${this.formatDate(this.startDate)}&end=${this.formatDate(
          this.endDate
        )}`;
      } else if (
        //only has end
        !this.searchValue &&
        this.startDate === null &&
        this.endDate != null &&
        this.acFilter === null
      ) {
        console.log('5')
        return `${this.ordermanageapi}/rfr?end=${this.formatDate(
          this.endDate
        )}`;
      } else if (
        //only has start
        !this.searchValue &&
        this.startDate != null &&
        this.endDate === null &&
        this.acFilter === null
      ) {
        console.log('6')
        return `${this.ordermanageapi}/rfr?start=${this.formatDate(
          this.startDate
        )}`;
      } else if (
        //has start and end
        !this.searchValue &&
        this.startDate != null &&
        this.endDate != null &&
        this.acFilter === null
      ) {
        console.log('7')
        return `${this.ordermanageapi}/rfr?start=${this.formatDate(
          this.startDate
        )}&end=${this.formatDate(this.endDate)}`;
      } else if (
        //has all 4
        this.searchValue.length &&
        this.startDate != null &&
        this.acFilter != null &&
        this.endDate != null
      ) {
        console.log('8')
        return `${this.ordermanageapi}/rfr?ac=${this.acFilter}`;
      } else if (
        //has only ac
        !this.searchValue &&
        this.startDate === null &&
        this.endDate === null &&
        this.acFilter != null
      ) {
        console.log('9')
        return `${this.ordermanageapi}/rfr?ac=${this.acFilter}`;
      } else if (
        //has ac and start
        !this.searchValue &&
        this.startDate != null &&
        this.acFilter != null &&
        this.endDate === null
      ) {
        console.log('10')
        return `${this.ordermanageapi}/rfr?start=${this.formatDate(
          this.startDate
        )}&ac=${this.acFilter}`;
      } else if (
        //has ac and end
        !this.searchValue &&
        this.startDate === null &&
        this.acFilter != null &&
        this.endDate != null
      ) {
        console.log('11')
        return `${this.ordermanageapi}/rfr?end=${this.formatDate(
          this.endDate
        )}&ac=${this.acFilter}`;
      } else if (
        //has ac and number
        this.searchValue.length &&
        this.startDate === null &&
        this.acFilter != null &&
        this.endDate === null
      ) {
        console.log('12')
        return `${this.ordermanageapi}/rfr?search=${this.searchValue.trim()}&ac=${this.acFilter}`;
      } else if (
        //has ac and start and end
        !this.searchValue &&
        this.startDate != null &&
        this.acFilter != null &&
        this.endDate != null
      ) {
        console.log('13')
        return `${this.ordermanageapi}/rfr?ac=${
          this.acFilter
        }&start=${this.formatDate(this.startDate)}&end=${this.formatDate(
          this.endDate
        )}`;
      } else if (
        //has ac, search and start
        this.searchValue.length &&
        this.startDate != null &&
        this.acFilter != null &&
        this.endDate === null
      ) {
        console.log('14')
        return `${this.ordermanageapi}/rfr?ac=${
          this.acFilter
        }&start=${this.formatDate(this.startDate)}&?search=${this.searchValue.trim()}`;
      } else if (
        //has ac, search and end
        this.searchValue.length &&
        this.startDate === null &&
        this.acFilter != null &&
        this.endDate != null
      ) {
        console.log('15')
        return `${this.ordermanageapi}/rfr?ac=${
          this.acFilter
        }&end=${this.formatDate(this.startDate)}&search=${this.searchValue.trim()}`;
      } else {
        console.log('16')
        return `${this.ordermanageapi}/rfr`;
      }
    },
  },
  created() {
    this.$store.commit("showNavigation");
    // console.log(this.$route.path);
  },

  mounted() {
    this.firstLoad();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media all and (min-width: 992px) {
  .flex-box-wrap {
    height: 200px;
    padding: 150px 0 125px 0;
    margin: 0;
  }
}

@media all and (max-width: 991px) {
  .flex-box-wrap {
    height: 100px;
    padding: 75px 0 50px 0;
    margin: 0;
    justify-content: center;
    align-items: center;
  }
}

.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #00b4b4;
  border-color: #00b4b4;
}

.listing {
  background-color: #fff;
  line-height: 44px;
  padding: 20px;
  margin-bottom: 5px;
  border-top: 0;
}
.top-wrap {
  display: flex;
  align-items: flex-start;
}
.rfr-bottom {
  align-items: flex-end;
}
.rfr-header {
  background: #fff;
  color: #575757;
  display: flex !important;
}
.small-lh {
  line-height: 1.4em;
}

.listing {
  overflow: scroll;
}

.table-responsive {
  display: table;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.03) !important;
}
.table-bordered td,
.table-bordered th {
  border: 1px solid #e8e8e8 !important;
}
.badge-success {
  color: #fff;
  background-color: #4d5967;
  background-color: #1eb5b6;
}
.table-striped a {
  color: #00b4b4;
}
.table-striped td,
.table-striped th {
  padding: 5px;
  font-weight: 300 !important;
}
.listing {
  border-radius: 4px;
}
table td {
  line-height: 1;
}
.table-striped th {
  background: #00b4b4;
  background: #4d5967;
  color: #fff;
  line-height: 1;
}
.search-btns {
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
}
.search-btns button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: #4d5967;
  color: #fff;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
  max-height: 40px;
  padding: 23px 10px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.search-btns .clear {
  margin-right: 0;
  margin-left: auto;
  padding: 23px 15px;
}
.search-btns .search {
  /*margin-left: auto;*/
  margin-right: 0;
  margin-left: auto;
}
.search-btns button span {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #fff;
}
.search-btns button:hover {
  background: #586575;
}
.search-btns button:active {
  background: #586575;
}
.search-btns button:disabled {
  opacity: 0.6;
  cursor: unset !important;
}
.search-btns button:disabled:hover {
  background: #4d5967;
}
.search-btns button:disabled:active {
  background: #4d5967;
}

@media all and (min-width: 768px) {
  .dates {
    display: flex;
    color: #757575 !important;
  }
}
.top-search {
  color: #757575;
}
select.form-control:not([size]):not([multiple]) {
  height: auto !important;
  padding: 10px !important;
  color: #757575;
}
.all-contractors {
  color: #757575 !important;
}
@media all and (max-width: 991px) {
  /*
  .listing {
    overflow: scroll;
  }
  */
  table {
    width: 900px !important;
    overflow: scroll;
  }
}
.clear-btn {
  position: absolute;
  right: 0;
  top: 14px;
  border: none;
  background: none;
}
.clear-hide {
  display: none !important;
}
.input-wrap {
  position: relative;
  display: block;
}

.header-bucket-wrap {
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    flex: 1;
}
.top-back {
    display: inline-block;
    padding: 10px;
    background: rgba(255, 255, 255, 0.2);
    color: #fff;
    border-radius: 4px;
    transition: background 0.5s ease;
    text-decoration: none;
}

.top-back:hover {
    background: rgba(255, 255, 255, 0.4);
}
.pixelsbg {
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23505a65'/%3E%3Cstop offset='1' stop-color='%23505a65' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233f474f'/%3E%3Cstop offset='1' stop-color='%233f474f' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23383e45'/%3E%3Cstop offset='1' stop-color='%23383e45' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%23474f58' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%23464f58' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%23464e57' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%23454e56' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23454d56' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%23444d55' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%23444c55' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%23434b54' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%23434b53' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23424a53' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23424a52' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23404850' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23404750' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%233f474f' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%233e454d' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%233e454c' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%233d444c' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%233d444b' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%233c434b' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%233c424a' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%233b4249' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%233b4149' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%233a4148' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%233a4047' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%23394047' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%23393f46' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%23383f46' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%23394047' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%233b4148' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%233c434a' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%233d444c' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%233f464e' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%2340474f' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23414951' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23434a53' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23444c55' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%23454d57' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%23474f58' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%2348515a' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%2349525c' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%234b545e' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%234c5560' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%234d5761' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%234f5963' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%23505a65' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%23515c67' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%23535d69' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%23545f6b' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2355616c' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2357626e' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%23586470' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%235a6672' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%235b6774' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%235c6976' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b78' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%235f6c7a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23616e7c' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%2362707d' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%2363717f' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23657381' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23667583' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23687685' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525b' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c555f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5660' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234d5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234e5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%234f5a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23505b65' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%23545f6a' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355606c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356616d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636e' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6773' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235c6976' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235d6a77' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%235f6d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23606e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23616f7c' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647280' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657382' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%23383e45' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='.5'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233c768a'/%3E%3Cstop offset='1' stop-color='%233c768a' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23305e6e'/%3E%3Cstop offset='1' stop-color='%23305e6e' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%231a8182'/%3E%3Cstop offset='1' stop-color='%231a8182' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%2346505a' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%2344515c' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%2343515d' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%2341525e' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23405260' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%233e5361' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%233d5462' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%233c5463' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%233a5565' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23395666' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23375767' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23365969' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23345a6a' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23335b6b' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23325d6c' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%23305e6e' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%232f606f' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%232d6170' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%232c6372' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%232b6573' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%23296774' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%23286975' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%23266b77' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%23256d78' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%23246f79' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%2322727a' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%2321747c' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%2320767d' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%231e797e' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%231d7c80' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%231b7e81' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%231c8083' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%231d8083' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%231f7f84' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%23217e85' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%23227e85' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%23247d86' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23267c87' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23287c87' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23297b88' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%232b7a88' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%232d7a88' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%232f7989' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%23317989' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%23337889' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%2335788a' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%2337778a' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%233a778a' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%233c768a' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%233e768a' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%2340758a' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%2343758a' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2345758a' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2347758a' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%234a758a' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%234c748a' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%234e748a' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%2351748a' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%2354758a' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%2356758a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23597589' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%235b7589' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%235e7689' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23617688' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23637788' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23667787' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525c' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c565f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5761' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234e5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234f5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%23505a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23515b66' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%2354606b' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355616c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356626d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636f' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6774' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235d6a76' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235e6b78' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235f6c79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%23606d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23616e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23626f7d' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647281' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657482' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%231a8182' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='0.79'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}

.header-bucket-wrap {
  cursor: pointer;
  transition: all 0.25s ease;
  border-radius: 8px;
}

.header-bucket-wrap:hover {
  background: rgba(255, 255, 255, 0.4) !important;
  transform: translateY(-2px);
}

.header-bucket-wrap.active {
  background: rgba(255, 255, 255, 0.4) !important;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.25);
}

.header-bucket-wrap.active:hover {
  background: rgba(255, 255, 255, 0.4) !important;
}
</style>
